import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import ReportsInfoActions from "../../../components/User/ReportsInfoComponents/ReportsInfoActions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import ReportsInfoTable from "../../../components/User/ReportsInfoComponents/ReportsInfoTable";

const { getRestaurants } = appActions;

const ReportsInfo = () => {
  const { selectedOrganization } = useProjectState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <>
      <PageHeader text="Справка по отчети" date={true} />
      <ReportsInfoActions />
      <ReportsInfoTable />
    </>
  );
};

export default ReportsInfo;
